<template>
  <div>
    <div>
      <jd-form
        :formData.sync="searchForm"
        :formInfo="searchFormInfo"
        :emitReset="false"
        immediately
        ref="formRef"
        @search="handkeSearch($event, 0)"
        @reset="handkeSearch($event, 1)"
      >
        <template #mutexActivityType="{ form }">
          <el-select
            v-model="form.resource"
            style="width: 105px"
            @change="form.mutexActivityType = ''"
          >
            <el-option label="全部" :value="''" />
            <el-option label="互动活动" :value="0" />
            <el-option label="积分兑换" :value="1" />
          </el-select>
          <el-select
            v-model="form.mutexActivityType"
            :disabled="
              form.resource == 1 || (form.resource && form.resource.length == 0)
            "
            style="width: 175px; margin-left: 10px"
          >
            <el-option label="全部" value="" />
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="(item, index) in activityTypeList"
              :key="index"
            />
          </el-select>
        </template>
      </jd-form>
    </div>
    <div class="mt16 flex-spc-x">
      <div class="flexc-cen-x">
        <jd-button type="blueLine" @click="handleSetConfig">
          订单互斥
        </jd-button>
        <jd-button @click="showAddAddRule"> 添加互斥规则 </jd-button>
      </div>
      <div>
        <el-checkbox v-model="isCreateByMe" @change="getList">
          我创建的
        </el-checkbox>
      </div>
    </div>
    <div class="mt16">
      <jd-table
        :tableData="tableList"
        :tableInfo="tableInfo"
        :loading="talbeLoading"
        style="width: 100%"
        ref="table"
        :pageInfo="tablepageInfo"
        @handlePage="handlePages"
      >
        <template #mutexActivityType="{ row }">
          {{
            row.resource == 0
              ? (activityTypeList.find(
                  (item) => item.value == row.mutexActivityType,
                ) &&
                  activityTypeList.find(
                    (item) => item.value == row.mutexActivityType,
                  ).label) ||
                ""
              : "积分兑换"
          }}
        </template>
        <template #status="{ row }">
          <el-switch
            v-model="row.status"
            :disabled="row.statusLoading"
            :active-value="1"
            :inactive-value="0"
            @change="handleStatusChange(row)"
          ></el-switch>
        </template>
        <template #operation="{ row }">
          <jd-button type="blueText" @click="handleEdit(row)">修改</jd-button>
          <jd-button type="blueText" @click="handleDelete(row)">删除</jd-button>
        </template>
      </jd-table>
    </div>
    <!-- 添加互斥规则 -->
    <jd-dialog
      title="添加互斥规则"
      :visible.sync="isShowAddRule"
      width="1200px"
      @close="isShowAddRule = false"
      @confirm="saveAddRule"
      :sureLoading="addLoading"
    >
      <jd-tip>
        <div>
          1.目前仅支持满额有礼、和积分兑换实现互斥规则，后续其余玩法会不断新增，敬请期待
        </div>
        <div>
          2.【互斥类型-互动活动】选择多个活动互斥即等于用户仅可以参与其中一个活动，如想实现效果请在活动开始前完成好配置，如在互斥前用户已参与多个活动，即不影响已参与活动，依旧可参与；
        </div>
        <div>
          3.【互斥类型-互动活动】可配置报名活动建议配置【用户报名参与】否则用户进入活动即等于参与，因为参与了导致互斥参与不了其他活动
        </div>
      </jd-tip>
      <div class="mt16">
        <el-form
          :model="addRuleForm"
          :rules="addRuleRules"
          ref="addRuleFormRef"
          label-width="120px"
        >
          <el-form-item label="规则名称" prop="ruleName" required>
            <el-input
              v-model="addRuleForm.ruleName"
              placeholder="请输入"
              show-word-limit
              maxlength="20"
              style="width: 320px"
            ></el-input>
          </el-form-item>
          <el-form-item label="互斥类型" prop="resource" required>
            <el-radio-group
              v-model="addRuleForm.resource"
              @change="addRuleForm.activityIdList = []"
            >
              <el-radio :label="0">互动玩法</el-radio>
              <el-radio :label="1">积分兑换</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="选择活动" prop="activityIdList" required>
            <div>
              <jd-button @click="selectActivity">选择活动</jd-button>
            </div>
            <div class="mt16">
              <jd-table
                :tableData="addRuleForm.activityIdList"
                style="width: 100%"
              >
                <el-table-column
                  label="活动名称"
                  prop="activityName"
                ></el-table-column>
                <el-table-column label="活动类型" prop="activityType">
                  <template #default="{ row }">
                    {{
                      addRuleForm.resource == 0
                        ? (activityTypeList.find(
                            (item) => item.value == row.activityType,
                          ) &&
                            activityTypeList.find(
                              (item) => item.value == row.activityType,
                            ).label) ||
                          ""
                        : (pointActivityTypeList.find(
                            (item) => item.value == row.activityType,
                          ) &&
                            pointActivityTypeList.find(
                              (item) => item.value == row.activityType,
                            ).label) ||
                          ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column label="活动时间" prop="activityTime">
                  <template #default="{ row }">
                    {{ row.startTime }} - {{ row.endTime }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" prop="operation">
                  <template #default="{ $index }">
                    <jd-button
                      type="blueText"
                      @click="addRuleForm.activityIdList.splice($index, 1)"
                      >删除</jd-button
                    >
                  </template>
                </el-table-column>
              </jd-table>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </jd-dialog>
    <!-- 选择活动 -->
    <jd-dialog
      title="选择活动"
      :visible.sync="isShowSelectActivity"
      width="1200px"
      @close="isShowSelectActivity = false"
      @confirm="
        addRuleForm.activityIdList = selectionList;
        isShowSelectActivity = false;
      "
    >
      <div v-if="isShowSelectActivity">
        <jd-form
          :formData.sync="activityForm"
          :formInfo="activityFormInfo"
          :emitReset="false"
          immediately
          ref="formRef"
          @search="searchActivity($event, 0)"
          @reset="searchActivity($event, 1)"
        ></jd-form>
      </div>
      <div class="mt16" v-if="isShowSelectActivity">
        <jd-table
          ref="activityTable"
          row-key="id"
          :tableData="activityList"
          :tableInfo="activityTableInfo"
          :loading="activityLoading"
          selection
          style="width: 100%"
          :pageInfo="activityPageInfo"
          @handlePage="handleActivityPages"
          @handleSelectionChange="handleSelect"
        >
          <template #activityType="{ row }">
            {{
              addRuleForm.resource == 0
                ? (activityTypeList.find(
                    (item) => item.value == row.activityType,
                  ) &&
                    activityTypeList.find(
                      (item) => item.value == row.activityType,
                    ).label) ||
                  "-"
                : (pointActivityTypeList.find(
                    (item) => item.value == row.activityType,
                  ) &&
                    pointActivityTypeList.find(
                      (item) => item.value == row.activityType,
                    ).label) ||
                  "-"
            }}
          </template>
          <template #activityTime="{ row }">
            {{ row.startTime }} - {{ row.endTime }}
          </template>
        </jd-table>
      </div>
    </jd-dialog>
    <!-- 活动配置弹窗 -->
    <jd-dialog
      title="活动配置"
      :visible.sync="isShowActivityConfig"
      width="500px"
      :before-close="beforeConfigclose"
    >
      <div
        style="display: flex; flex-direction: column; line-height: 16px"
        v-loading="configLoading"
      >
        <div style="margin-bottom: 20px">勾选如下配置后保存表示对应规则：</div>
        <div style="margin-left: 10px">
          <el-checkbox
            v-model="activityConfig.checkExistOrder"
            :true-label="1"
            :false-label="0"
          ></el-checkbox>
          <span style="margin-left: 10px; line-height: 24px"
            >同类型活动下，同个订单只能被解锁成功1次（生效活动：首购有礼、复购有礼、下单有礼、下单抽奖、预售有礼、预售抽奖、会员成长计划）</span
          >
          <el-popover
            placement="top-start"
            width="400"
            offset="100"
            trigger="hover"
            content="该配置仅在单类型的活动生效，不跨类型活动；比如：下单有礼有3个活动，则一个订单在其中一个活动解锁成功后不能在其它两个活动解锁；"
          >
            <span style="" slot="reference">
              <i class="new-icon-box" style="margin: -2px 2px"></i>
            </span>
          </el-popover>
        </div>
      </div>
      <div slot="footer">
        <jd-button @click="isShowActivityConfig = false">取 消</jd-button>
        <jd-button
          type="blue"
          style="margin-left: 8px"
          @click="handleConfirmConfig"
          >保 存</jd-button
        >
      </div>
    </jd-dialog>
  </div>
</template>

<script>
import {
  activityMutexRulePage,
  getActivitySetting,
  saveActivitySetting,
  queryActivity,
  activityMutexRuleSave,
  activityMutexRuleSwitch,
  activityMutexRuleDelete,
  activityMutexRuleDetail,
} from "@/api/jhk/activityController.js";
import { exchangeActivityList } from "@/api/jhk/paradiseAndTaskCommonController.js";
export default {
  name: "mutualExclusion",
  data() {
    return {
      addLoading: false,
      selectionList: [],
      activityList: [],
      activityTableInfo: [
        {
          label: "活动名称",
          prop: "activityName",
        },
        {
          label: "活动类型",
          slot: "activityType",
        },
        {
          label: "活动时间",
          slot: "activityTime",
        },
        {
          label: "活动状态",
          prop: "status",
          formatter: (row) => {
            return row.status == 1
              ? "未开始"
              : row.status == 2
              ? "进行中"
              : "已结束";
          },
        },
      ],
      activityLoading: false,
      activityPageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      activityForm: {},
      isShowSelectActivity: false,
      addRuleForm: {
        resource: 0,
        activityIdList: [],
        ruleName: "",
      },
      addRuleRules: {
        ruleName: [
          { required: true, message: "请输入规则名称", trigger: "blur" },
        ],
        resource: [
          { required: true, message: "请选择互斥类型", trigger: "change" },
        ],
        activityIdList: [
          { required: true, message: "请选择活动", trigger: "change" },
        ],
      },
      isShowAddRule: false,
      configLoading: false,
      activityConfig: {
        checkExistOrder: 0,
        id: "",
        activityType: 0,
      },
      isShowActivityConfig: false,
      isCreateByMe: false,
      tableInfo: [
        {
          label: "规则名称",
          prop: "ruleName",
        },
        {
          label: "活动类型",
          slot: "mutexActivityType",
        },
        {
          label: "是否开启",
          slot: "status",
        },
        {
          label: "创建时间",
          prop: "createdAt",
        },
        {
          label: "更新时间",
          prop: "updatedAt",
        },
        {
          label: "操作",
          slot: "operation",
        },
      ],
      tablepageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      talbeLoading: false,
      searchForm: {},
      tableList: [],
      activityTypeList: [
        {
          label: "满额有礼",
          value: "46",
        },
      ],
      pointActivityTypeList: [
        { label: "兑换实物", value: 9 },
        { label: "兑换优惠券", value: 10 },
        { label: "兑换京豆", value: 29 },
        { label: "兑换E卡", value: 30 },
        { label: "兑换红包", value: 38 },
        { label: "积分加钱购", value: 55 },
        { label: "兑换爱奇艺会员", value: 58 },
        { label: "兑换PLUS会员", value: 59 },
        { label: "兑换礼品卡", value: 60 },
        { label: "兑换百度网盘", value: 61 },
      ],
    };
  },
  computed: {
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    },
    activityFormInfo() {
      return [
        {
          label: "活动名称：",
          prop: "activityName",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "活动类型：",
          prop: "activityType",
          type: "Select",
          placeholder: "请选择",
          value:
            this.addRuleForm.resource == 0
              ? this.activityTypeList[0].value
              : "",
          options:
            this.addRuleForm.resource == 0
              ? this.activityTypeList
              : [
                  {
                    label: "全部",
                    value: "",
                  },
                  ...this.pointActivityTypeList,
                ],
        },
        {
          label: "活动时间：",
          type: "DateRange",
          defalutLimit: true,
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
        },
        {
          label: "最后修改时间：",
          type: "DateRange",
          defalutLimit: true,
          dateType: "datetime",
          startKey: "startUpdateTime",
          endKey: "endUpdateTime",
        },
      ];
    },
    searchFormInfo() {
      return [
        {
          label: "规则名称：",
          prop: "ruleName",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "活动类型：",
          prop: "mutexActivityType",
          value: "",
          slot: "mutexActivityType",
        },
        {
          label: "互动类型",
          prop: "resource",
          value: "",
          isHide: true,
        },
        {
          label: "是否开启：",
          prop: "status",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            {
              label: "全部",
              value: "",
            },
            {
              label: "是",
              value: "1",
            },
            {
              label: "否",
              value: "0",
            },
          ],
        },
        {
          label: "最后修改时间：",
          type: "DateRange",
          defalutLimit: true,
          dateType: "datetime",
          startKey: "updateStartTime",
          endKey: "updateEndTime",
        },
      ];
    },
  },
  methods: {
    handleEdit(row) {
      this.talbeLoading = true;
      activityMutexRuleDetail({
        id: row.id,
      }).then((res) => {
        this.talbeLoading = false;
        if (res.code == 1) {
          res.data.activityIdList = res.data.mutexActivities.map((v) => ({
            ...v,
            activityType: v.subType,
          }));
          this.addRuleForm = res.data;
          this.isShowAddRule = true;
        }
      });
    },
    handleDelete(row) {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((result) => {
        if (result == "confirm") {
          // 确认删除
          activityMutexRuleDelete(row.id).then((res) => {
            if (res.code == 1) {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.warning(res.message);
            }
          });
        }
      });
    },
    showAddAddRule() {
      this.addRuleForm = {
        resource: 0,
        activityIdList: [],
        ruleName: "",
      };
      this.isShowAddRule = true;
    },
    saveAddRule() {
      this.$refs.addRuleFormRef.validate((valid) => {
        if (valid) {
          if (this.addRuleForm.activityIdList.length < 2) {
            this.$message.warning("请选择至少两个活动");
            return;
          }
          // 校验通过
          let data = { ...this.addRuleForm };
          if (data.resource == 0) {
            data.mutexActivityType = 46;
          }
          data.venderId = this.venderId;
          data.activityIdList = data.activityIdList.map((v) => v.id);
          this.addLoading = true;
          activityMutexRuleSave(data)
            .then((res) => {
              this.addLoading = false;
              if (res.code == 1) {
                this.$message.success("保存成功");
                this.isShowAddRule = false;
                this.getList();
              } else {
                this.$message.warning(res.message);
              }
            })
            .catch((err) => {
              console.error(err);
              this.addLoading = false;
            });
        }
      });
    },
    selectActivity() {
      this.selectionList = this.addRuleForm.activityIdList || [];
      this.isShowSelectActivity = true;
    },
    handleSelect(selection) {
      console.log(selection);

      this.selectionList = selection;
    },

    handleActivityPages(page) {
      this.activityPageInfo.pageNum = page.pageNum;
      this.activityPageInfo.pageSize = page.pageSize;
      this.getActivityList();
    },
    searchActivity(form, type) {
      this.activityPageInfo.pageNum = 1;
      this.activityPageInfo.pageSize = 10;
      this.activityForm = form;
      this.getActivityList();
    },
    getActivityList() {
      let data = { ...this.activityForm };
      data.current = this.activityPageInfo.pageNum;
      data.size = this.activityPageInfo.pageSize;
      this.activityLoading = true;
      let reqApi =
        this.addRuleForm.resource == 1 ? exchangeActivityList : queryActivity;
      reqApi(data)
        .then((res) => {
          this.activityLoading = false;
          if (res.code == 1) {
            this.activityList = res.data.records;
            this.activityList.forEach((item) => {
              const flag = this.selectionList.find((v) => v.id == item.id);
              if (flag) {
                this.$nextTick(() => {
                  this.$refs.activityTable.toggleRowSelection(item, true);
                });
              }
            });
            this.activityPageInfo.total = Number(res.data.total);
          } else {
            this.$message.warning(res.message);
          }
        })
        .catch((err) => {
          console.error(err);
          this.activityLoading = false;
        });
    },
    handleStatusChange(row) {
      let data = {
        id: row.id,
        status: row.status,
      };
      this.$set(row, "statusLoading", true);
      activityMutexRuleSwitch(data).then((res) => {
        this.$set(row, "statusLoading", false);
        if (res.code == 1) {
          this.$message.success("操作成功");
          this.getList();
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    //保存配置
    handleConfirmConfig() {
      this.isShowActivityConfig = false;
      saveActivitySetting(this.activityConfig)
        .then((res) => {
          this.$message.success("保存成功");
        })
        .catch(() => {
          this.$message.error("保存失败");
        });
    },
    beforeConfigclose() {
      this.isShowActivityConfig = false;
    },
    // 打开弹窗获取配置
    handleSetConfig() {
      this.isShowActivityConfig = true;
      this.getActivityConfig();
    },
    //获取活动配置
    getActivityConfig() {
      this.configLoading = true;
      getActivitySetting({ activityType: 0 })
        .then((res) => {
          if (res.data && "checkExistOrder" in res.data) {
            let { checkExistOrder, id } = res.data;
            this.activityConfig.checkExistOrder = checkExistOrder;
            this.activityConfig.id = id;
          }
        })
        .catch(() => {
          this.$message.error("获取失败");
        })
        .finally(() => {
          this.configLoading = false;
        });
    },
    // 分页查询事件
    handlePages(page) {
      this.tablepageInfo.pageNum = page.pageNum;
      this.tablepageInfo.pageSize = page.pageSize;
      this.getList();
    },
    handkeSearch(form, type) {
      this.tablepageInfo.pageNum = 1;
      this.tablepageInfo.size = 10;
      this.searchForm = form;
      this.getList();
    },
    getList() {
      let data = { ...this.searchForm };
      data.current = this.tablepageInfo.pageNum;
      data.size = this.tablepageInfo.pageSize;
      data.createByMe = this.isCreateByMe;
      this.talbeLoading = true;
      activityMutexRulePage(data)
        .then((res) => {
          if (res.code == 1) {
            this.tableList = res.data.records;
            this.tablepageInfo.total = Number(res.data.total || 0);
          } else {
            this.$message.warning(res.message);
          }
          this.talbeLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.talbeLoading = false;
        });
    },
  },
};
</script>

<style></style>
